import script from "./AppIdleModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AppIdleModal.vue?vue&type=script&setup=true&lang=js"

import "./AppIdleModal.vue?vue&type=style&index=0&id=50ed0903&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50ed0903"]])

export default __exports__